(() => {
  class LensCategory extends HTMLElement {
    static get observedAttributes() {
      return [
        "data-visibility-condition",
        "data-variant-title",
        "data-element-title",
      ];
    }

    attributeChangedCallback() {
      this.updateSelectedCat();
    }
    connectedCallback() {
      this.render();
      this.updateSelectedCat();
    }

    normalizeAndSplit(title = "") {
      return String(title)
        .toLowerCase()
        .replace(/ /g, "")
        .replace(/-cat/g, "__cat")
        .replace(/[\/()]/g, "")
        .split("__");
    }

    render() {
      const visibility = (this.getAttribute("data-visibility-condition") || "")
        .trim()
        .toLowerCase();
      const isSummer =
        visibility === "summer" || visibility === "" || visibility == null;
      const label = this.getAttribute("data-element-title") || "Product type";
      const cat0 =
        this.getAttribute("data-product_type_cat0") || "Cat.0 (Summer)";
      const cat1 =
        this.getAttribute("data-product_type_cat1") || "Cat.1 (Summer)";
      const cat0Winter =
        this.getAttribute("data-product_type_cat0_winter") || "Cat.0 (Winter)";
      const cat1Winter =
        this.getAttribute("data-product_type_cat1_winter") || "Cat.1 (Winter)";
      const cat2 = this.getAttribute("data-product_type_cat2") || "Cat.2";
      const cat3 = this.getAttribute("data-product_type_cat3") || "Cat.3";
      const cat4 = this.getAttribute("data-product_type_cat4") || "Cat.4";
      this.innerHTML = `
				<div class="product__tags product__tags--bundle">
					<div class="tags__title">${label}</div>
					<div class="tags__content">
						${
              isSummer
                ? `
							<div class="tag" data-type="cat.0">
								<div class="tag__icon i-type-1"></div>
								<div class="tag__title">${cat0}</div>
								<div class="tag__type">Cat.0</div>
							</div>
							<div class="tag" data-type="cat.1">
								<div class="tag__icon i-type-2"></div>
								<div class="tag__title">${cat1}</div>
								<div class="tag__type">Cat.1</div>
							</div>
						`
                : `
							<div class="tag" data-type="cat.0">
								<div class="tag__icon i-type-6"></div>
								<div class="tag__title">${cat0Winter}</div>
								<div class="tag__type">Cat.0</div>
							</div>
							<div class="tag" data-type="cat.1">
								<div class="tag__icon i-type-7"></div>
								<div class="tag__title">${cat1Winter}</div>
								<div class="tag__type">Cat.1</div>
							</div>
						`
            }
						<div class="tag" data-type="cat.2">
							<div class="tag__icon i-type-3"></div>
							<div class="tag__title">${cat2}</div>
							<div class="tag__type">Cat.2</div>
						</div>
						<div class="tag" data-type="cat.3">
							<div class="tag__icon i-type-4"></div>
							<div class="tag__title">${cat3}</div>
							<div class="tag__type">Cat.3</div>
						</div>
						<div class="tag" data-type="cat.4">
							<div class="tag__icon i-type-5"></div>
							<div class="tag__title">${cat4}</div>
							<div class="tag__type">Cat.4</div>
						</div>
					</div>
				</div>
			`;
    }

    updateSelectedCat() {
      const variantTitle = this.getAttribute("data-variant-title") || "";
      const parts = this.normalizeAndSplit(variantTitle);
      const catExist = Boolean(parts[1] && parts[1].includes("cat."));
      const selectedCat = catExist ? parts[1] : "";
      const tags = this.querySelectorAll(".tag");
      if (!catExist) {
        this.innerHTML = "";
        return;
      }
      tags.forEach((tag) => {
        if (tag.getAttribute("data-type") === selectedCat) {
          tag.classList.add("is-selected");
        } else {
          tag.classList.remove("is-selected");
        }
      });
    }
  }

  if (!customElements.get("lens-category")) {
    customElements.define("lens-category", LensCategory);
  }
})();
